module.exports = __webpack_public_path__ + "img/loginbg.1ecf7020.webp";